import { SettingsValue } from "types/payments";

export type AccountPermissionStatus =
  | "idle"
  | "loading"
  | "succeeded"
  | "failed";

interface DocumentsPermissionContext {
  accountPermission?: Record<string, any> | null;
  accountPermissionStatus: AccountPermissionStatus;
  accountPermissionClusterId?: string | null;
  currentClusterId?: string | null;
}

const isCurrentClusterPermission = ({
  accountPermissionClusterId,
  currentClusterId,
}: Pick<
  DocumentsPermissionContext,
  "accountPermissionClusterId" | "currentClusterId"
>) =>
  Boolean(accountPermissionClusterId) &&
  Boolean(currentClusterId) &&
  String(accountPermissionClusterId) === String(currentClusterId);

/**
 * Feature access is intentionally fail-closed. Missing, stale, loading, and
 * failed permission data must never be interpreted as authorization.
 */
export const canViewCustomerPortalDocuments = (
  context: DocumentsPermissionContext
) =>
  context.accountPermissionStatus === "succeeded" &&
  isCurrentClusterPermission(context) &&
  context.accountPermission?.view_docs === SettingsValue.YES;

export const isDocumentsPermissionPending = (
  context: DocumentsPermissionContext
) =>
  context.accountPermissionStatus === "idle" ||
  context.accountPermissionStatus === "loading" ||
  !isCurrentClusterPermission(context);

export const getVisibleCustomerPortalMenuItems = <T extends { id: string }>(
  items: T[],
  context: DocumentsPermissionContext
) =>
  items.filter(
    (item) =>
      item.id !== "documents" || canViewCustomerPortalDocuments(context)
  );
